import { location } from '@/services'
import { useQuery } from '@tanstack/react-query'

// ----------------------------------------------------------------------

type ReturnType = {
  dataDistricts: District[] | undefined
  isLoadingDataDistricts: boolean
  isPendingDataDistrict: boolean
}

export function useDistrict(addressType: string, cityId?: string | number, isEnabled?: boolean): ReturnType {
  const {
    data: dataDistricts,
    isLoading: isLoadingDataDistricts,
    isPending: isPendingDataDistrict,
  } = useQuery({
    queryKey: ['GET_DATA_DISTRICTS', cityId?.toString(), addressType],
    queryFn: async () => location.getDistricts(cityId as number, addressType),
    enabled: !!cityId && !!addressType && isEnabled,
    retry: 0,
  })

  return {
    dataDistricts,
    isLoadingDataDistricts,
    isPendingDataDistrict,
  }
}

export function useOldDistrict(cityId?: string | number) {
  const {
    data: dataDistricts,
    isLoading: isLoadingDataDistricts,
    isPending: isPendingDataDistrict,
  } = useQuery({
    queryKey: ['GET_DATA_OLD_DISTRICTS', cityId?.toString()],
    queryFn: async () => location.getOldDistricts(cityId as number),
    enabled: !!cityId,
    retry: 0,
  })

  return {
    dataDistricts,
    isLoadingDataDistricts,
    isPendingDataDistrict,
  }
}
